import { resolveDefectHierarchyFields } from '@/features/defect-drawer/utils/resolveDefectHierarchyFields';

function eq(a, b) {
  return a != null && b != null && String(a) === String(b);
}

/**
 * siteDesign 모듈 / 지도 클릭 target 과 결함이 같은 모듈인지 (PK 또는 display ID 경로)
 * @param {object} defect
 * @param {object} moduleRef — { seq, displayId, arrayDisplayId, stringDisplayId }
 */
export function defectBelongsToModule(defect, moduleRef) {
  if (!defect || !moduleRef) return false;

  const h = resolveDefectHierarchyFields(defect);

  if (moduleRef.seq != null && h.solarModuleSeq != null && eq(h.solarModuleSeq, moduleRef.seq)) {
    return true;
  }

  if (moduleRef.displayId == null || h.moduleDisplayId == null) {
    return false;
  }
  if (!eq(h.moduleDisplayId, moduleRef.displayId)) {
    return false;
  }
  if (moduleRef.stringDisplayId != null && h.stringDisplayId != null && !eq(h.stringDisplayId, moduleRef.stringDisplayId)) {
    return false;
  }
  if (moduleRef.arrayDisplayId != null && h.arrayDisplayId != null && !eq(h.arrayDisplayId, moduleRef.arrayDisplayId)) {
    return false;
  }

  return true;
}

/**
 * @param {object} moduleRef
 * @returns {string|null}
 */
export function buildModuleDisplayKey(moduleRef) {
  if (!moduleRef?.displayId) return null;
  const arrayPart = moduleRef.arrayDisplayId != null ? String(moduleRef.arrayDisplayId) : '';
  const stringPart = moduleRef.stringDisplayId != null ? String(moduleRef.stringDisplayId) : '';
  const modulePart = String(moduleRef.displayId);
  return `${arrayPart}:${stringPart}:${modulePart}`;
}

/**
 * @param {object} defect
 * @returns {string|null}
 */
export function buildDefectModuleDisplayKey(defect) {
  const h = resolveDefectHierarchyFields(defect);
  if (h.moduleDisplayId == null) return null;
  return buildModuleDisplayKey({
    displayId: h.moduleDisplayId,
    arrayDisplayId: h.arrayDisplayId,
    stringDisplayId: h.stringDisplayId
  });
}

/**
 * @param {object} target — map highlight / drawer row
 * @param {object[]} defects
 */
export function filterDefectsForModuleTarget(target, defects) {
  if (!target || !defects?.length) return [];
  if (target.kind !== 'panel' && target.kind !== 'panel_single') return [];

  const moduleRef = {
    seq: target.seq,
    displayId: target.displayId,
    arrayDisplayId: target.arrayDisplayId,
    stringDisplayId: target.stringDisplayId
  };

  return defects.filter(d => defectBelongsToModule(d, moduleRef));
}
